import axios from 'axios';


export const getSecurityRoles = (org_id?: number) => {
  let theQuery = '';
  if (org_id) {
    theQuery = `org_id=${org_id}`;
  }
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL +
      `department/security-role?` +
      theQuery
  );
};
export const AddSecurityRoles = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/security-role/create`,
    obj,
    { headers }
  );
};

export const EditSecurityRoles = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/security-role/update`,
    obj,
    { headers }
  );
};
export const DeleteSecurityRoles = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/security-role/delete`,
    obj,
    { headers }
  );
};
